import { CFDClientMessage } from 'hooks/useHardwareAgent/CFD/types'
import {
    IDisplayOrderLine,
    TOrderPrice,
} from 'views/CustomerFacingDisplay/components/OrderDisplay/interface'
export enum CFDClientMessageType {
    Connected = 'Connected',
    Order = 'Order',
    Payment = 'Payment',
    FinishPayment = 'FinishPayment',
}
export interface CustomerFacingDisplayState {
    payload: CFDClientMessage | undefined
    state: CFDClientMessageType
    clientID: string | undefined
    hwAgentUrl: string | undefined
    isConnected: boolean
    isManualConnect: boolean
    isLoadedLocalSetting: boolean
}
type baseMessage = {
    posClientID: string
    timestamp?: string
}
export type PaymentMessageType = {
    totaldue?: number
    paymentTypeID?: number
    /**base64 */
    image?: string
    accountName?: string
    accountBalance?: number
    /**
     * extar message for other
     */
    message?: string
}
export type FinishPaymentMessageType = {
    isSuccessful: boolean
    changeAmount?: number
    email?: string
    message?: string
}
export type IOrderDisplay = TOrderPrice & {
    customerName?: string
    orderNote?: string
    orderName?: string
}
export type OrderMessageType = IOrderDisplay & {
    tableGroupName?: string
    tableName?: string
    orderItems: IDisplayOrderLine[]
    multipleOrderDetails?: IOrderDisplay[]
}
export type ISendToPOSMessage = Omit<baseMessage, 'posClientID'> &
    (
        | {
              type: CFDClientMessageType.Connected
              payload?: undefined
          }
        | {
              type: CFDClientMessageType.Payment
              payload: PaymentMessageType
          }
        | {
              type: CFDClientMessageType.FinishPayment
              payload: FinishPaymentMessageType
          }
        | {
              type: CFDClientMessageType.Order
              payload?: OrderMessageType
          }
    )
